export default __webpack_public_path__ + "static/media/e-commerce-endgame.ed49c7db.png";